import "./tailwind.css";
import { MobileMenu } from "./utils/mobile";

console.debug("index");



window.onload = () => {

  const mobile_nav = document.getElementById("mobile_nav");
  console.debug("Mobile Nav", mobile_nav);
  if (mobile_nav) {
    const mobileMenu = new MobileMenu();
    console.debug("Mobile Nav", mobile_nav);
    mobile_nav.addEventListener("click", mobileMenu.mobile_nav);
    const menu_close = document.getElementById("menu_close");
    if (menu_close) {
      menu_close.addEventListener("click", mobileMenu.mobile_nav);
    }
  } else {
    const observer = new MutationObserver(() => {
      const mobile_nav = document.getElementById("mobile_nav");
      if (mobile_nav) {
        const mobileMenu = new MobileMenu();
        console.debug("Mobile Nav", mobile_nav);
        mobile_nav.addEventListener("click", mobileMenu.mobile_nav);
        const menu_close = document.getElementById("menu_close");
        if (menu_close) {
          menu_close.addEventListener("click", mobileMenu.mobile_nav);
        }
        // Arrête l'observation
        observer.disconnect();
      }
    });
  }
  window.addEventListener("scroll", () => {
    const scrollpos = window.scrollY;
    const header = document.getElementById("header");
    const menu = document.getElementById("header-menu");
    const mobile = document.getElementById("header-menu-mobile");
    const logo = document.getElementById("header-logo");

    if (scrollpos > 0 && header) {
      header.classList.add("shadow-sm");
      header.classList.remove("shadow-none");
      logo?.classList.remove("h-24");
      logo?.classList.add("h-16");
      menu?.classList.remove("mt-6");
      menu?.classList.add("mt-3");
      mobile?.classList.add("mt-0");
      mobile?.classList.remove("mt-4");
    } else if (scrollpos <= 0 && header) {
      header.classList.add("shadow-none");
      header.classList.remove("shadow-sm");
      logo?.classList.remove("h-16");
      logo?.classList.add("h-24");
      menu?.classList.remove("mt-3");
      menu?.classList.add("mt-6");
      mobile?.classList.add("mt-4");
      mobile?.classList.remove("mt-0");
    }
  });
};
